import { z } from 'zod'

export const fileSchema = z.object({
  key: z.string(),
  bucket: z.string(),
  name: z.string().optional(),
  url: z.string().optional(),
})
